import React, { useEffect, useState } from 'react'

import './Header.scss'
import HeaderTop from './HeaderTop'
import HeaderMenu from './HeaderMenu'
import axiosConfig from '~/api/axios-config'

const Header = () => {
	const [active, setActive] = useState(false)
	const [categories, setCategories] = useState()

	const toggleActiveMenu = () => {
		setActive((active) => !active)
	}

	useEffect(() => {
		axiosConfig
			.get('/category/getall')
			.then((res) => {
				// console.log(res.data.categories)
				setCategories(res.data.categories)
			})
			.catch((err) => {
				console.log(err)
			})
	}, [])

	return (
		<header className='header'>
			<HeaderTop toggleActiveMenu={toggleActiveMenu} />
			<HeaderMenu
				active={active}
				toggleActiveMenu={toggleActiveMenu}
				categories={categories}
			/>
		</header>
	)
}

export default Header
